module.exports = __webpack_public_path__ + "static/img/banner.6e9d925.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/banner.jpg
// module id = X+xI
// module chunks = 14